import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { getImageUrl } from '@/utils/string';
import { imageTypes, screenTypes } from '@/constants/types';
import useWindowDimensions from '@/app/hooks/useWindowSize';
import Button from '@/app/components/Button';
import Link from 'next/link';
import { EXTERNAL, WEB } from '@/constants';
import ImageComponentV2 from '../Image/ImageComponentV2';
import ButtonLabel from '../Typography/ButtonLabel';

function ProductLastCard({ image, sectionRedirectUrl, onClose }) {
  const router = useRouter();
  const windowDimensions = useWindowDimensions();
  const [imageUrl, setImageUrl] = useState('');

  useEffect(() => {
    if (typeof image === 'string') {
      setImageUrl(JSON.parse(image));
    } else {
      setImageUrl(image);
    }
  }, [image]);

  const getImageDimensionUrl = (imgUrl) => {
    if (!imgUrl) return null;
    const imageSize =
      windowDimensions.width > screenTypes.medium
        ? imgUrl?.large
        : imgUrl?.small;

    return imageSize;
  };

  const handleClickUrl = (e, url) => {
    e.stopPropagation();
    // e.preventDefault();

    if (onClose) {
      onClose();
    }

    if (!url) return null;

    if (url?.en?.type === WEB) {
      router.push(url?.en?.url);
    } else if (url?.en?.type === EXTERNAL) {
      window.open(url?.en?.url, '_blank');
    }
  };

  const handleSimilarItemUrl = (e, url) => {
    e.stopPropagation();

    if (onClose) {
      onClose();
    }

    router.push(url);
  };

  return (
    <div className="flex flex-col justify-between items-center gap-[5px] lg:gap-[20px] bg-pale-grey max-w-[180px] w-full lg:max-w-[300px] max-h-[368px] lg:max-h-[522px] h-screen px-8 pt-[49px] pb-10 lg:pb-16 shadow-what-are-you-looking-for-box-shadow rounded-[7px] lg:rounded-xl relative overflow-hidden hover:shadow-card-hover transition-colors duration-200">
      <div className="relative max-h-[238px] lg:max-h-[415px] overflow-hidden">
        <ImageComponentV2
          src={imageUrl ? getImageUrl(getImageDimensionUrl(imageUrl)) : null}
          alt="explore all image"
          className="w-full h-full"
          type={imageTypes.tall}
          height={415}
          loading="lazy"
        />
      </div>
      <Link
        prefetch={false}
        aria-label="Go to explore all deals"
        href={sectionRedirectUrl?.en?.url}
        passHref
        className="w-full"
      >
        <Button
          type="explore-all-deals"
          onClick={(e) => {
            if (onClose) {
              handleSimilarItemUrl(e, sectionRedirectUrl);
            } else {
              handleClickUrl(e, sectionRedirectUrl);
            }
          }}
        >
          <ButtonLabel className="text-xs lg:text-base text-white font-semibold">
            Explore All <span className="hidden lg:inline-block">Deals</span>
          </ButtonLabel>
        </Button>
      </Link>
    </div>
  );
}

export default ProductLastCard;
